import type { Address } from '@ui/types/alias';

export enum DecreaseOrderKind {
  TP = 0,
  SL = 1,
}

export type DecreaseOrderStatus = 'ACTIVE' | 'FILLED' | 'CANCELLED';

export type DecreaseOrderRow = {
  orderHash: Address;
  user: Address;
  positionHash: Address;
  pairBase?: Address;
  isLong?: boolean;
  kind: 'TP' | 'SL';
  triggerPrice: bigint;
  closeQty: bigint;
  broker: number;
  createdAt?: number;
  active?: boolean;
  status: DecreaseOrderStatus;
};

